const Q = require('q');
const idbKeyval = require('idb-keyval');
const model = require('model/model');

let offlineStore = null;
if ('indexedDB' in window) {
	// Custom store necessary for idbWriteable check
	// https://github.com/jakearchibald/idb-keyval/blob/main/custom-stores.md
	function createStore(dbName, storeName) {
		const request = indexedDB.open(dbName);
		request.onupgradeneeded = () => request.result.createObjectStore(storeName);
		const dbp = idbKeyval.promisifyRequest(request);

		return (txMode, callback) =>
			dbp
				.then(db => callback(db.transaction(storeName, txMode).objectStore(storeName)))
				.catch(() => {
					model.set('idbWriteable', false);
				});
	}

	offlineStore = createStore('offline-db', 'offline-data-store');
} else {
	model.set('idbWriteable', false);
}

const prmsCache = {};

const doOperation = (operation, key, ...opArgs) => {
	let prms = null;
	let prmsKey = operation + '/' + key;
	let idbOperation = operation === 'remove' ? 'del' : operation;

	if (prmsCache[prmsKey]) {
		prms = prmsCache[prmsKey];
	} else {
		let deferred = Q.defer();
		idbKeyval[idbOperation](key, ...opArgs)
			.then(result => {
				let value = operation === 'get' ? result : opArgs[0];
				if (operation === 'remove') {
					value = undefined;
					model.remove(key);
				} else {
					model.set(key, value);
				}
				prmsCache[prmsKey] = null;
				deferred.resolve(value);
			})
			.catch(e => {
				deferred.reject(e);
			});
		prms = deferred.promise;
		prmsCache[prmsKey] = prms;
	}
	return prms;
};

module.exports = {
	get(key) {
		return doOperation('get', key, offlineStore);
	},
	set(key, value) {
		return doOperation('set', key, value, offlineStore);
	},
	remove(key) {
		return doOperation('remove', key, offlineStore);
	},
	keys() {
		let deferred = Q.defer();
		idbKeyval
			.keys(offlineStore)
			.then(result => {
				deferred.resolve(result);
			})
			.catch(e => {
				deferred.reject(e);
			});
		return deferred.promise;
	},
	clear() {
		return idbKeyval.clear(offlineStore);
	}
};
